import { Component } from '@angular/core';
import { getCookie } from '../../utils/getCookies';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-sidebar-user',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './sidebar-user.component.html',
  styleUrl: './sidebar-user.component.scss'
})
export class SidebarUserComponent {

  showSidebarMobile: boolean = false;

  constructor(private router: Router) {}

  navigateToHome() {
    this.router.navigate(['/dashboard/user']);
  }

  isActive(path: string): boolean {
    return this.router.url === path;
  }

  navigateTo(path: string) {
    this.router.navigate([path]);
  }

}
